import type { EpisodeView } from "../scenes.ts";
import { isMac } from "./app.ts";
import type { ViewMode } from "./Browser.tsx";
import { Icon } from "./icons.tsx";

const SHORT = isMac ? "⌥⌘" : "Alt+Ctrl+";

export function ViewToggle({ mode, onMode }: { mode: ViewMode; onMode: (m: ViewMode) => void }) {
  return (
    <fieldset className="seg icon-seg">
      <legend className="sr-only">View</legend>
      <button
        type="button"
        aria-pressed={mode === "grid"}
        aria-label="Grid"
        title={`Grid (${SHORT}1)`}
        className={mode === "grid" ? "on" : ""}
        onClick={() => onMode("grid")}
      >
        <Icon name="grid" />
      </button>
      <button
        type="button"
        aria-pressed={mode === "list"}
        aria-label="List"
        title={`List (${SHORT}2)`}
        className={mode === "list" ? "on" : ""}
        onClick={() => onMode("list")}
      >
        <Icon name="list" />
      </button>
    </fieldset>
  );
}

/** By scene / All shots, in the toolbar of an episode. "By scene" is off while the episode has no named scenes. */
export function EpisodeViewSwitch({
  view,
  onView,
  enabled,
}: {
  view: EpisodeView;
  onView: (v: EpisodeView) => void;
  enabled: boolean;
}) {
  return (
    <fieldset className="seg text-seg" title={enabled ? undefined : "This episode has no named scenes yet"}>
      <legend className="sr-only">Show shots</legend>
      <button
        type="button"
        aria-pressed={view === "scenes"}
        className={view === "scenes" ? "on" : ""}
        disabled={!enabled}
        onClick={() => onView("scenes")}
      >
        By scene
      </button>
      <button
        type="button"
        aria-pressed={view === "all"}
        className={view === "all" ? "on" : ""}
        onClick={() => onView("all")}
      >
        All shots
      </button>
    </fieldset>
  );
}
